import {
  AUTH_PROVIDER_KEY,
  AUTH_PROVIDER_LEGACY,
  AUTH_PROVIDER_MOS,
} from '@commons/auth/constants';

export const getAuthProvider = () => window.localStorage.getItem(AUTH_PROVIDER_KEY);

export const isMosAuthProvider = () => getAuthProvider() === AUTH_PROVIDER_MOS;

export const isLegacyAuthProvider = () => {
  const provider = getAuthProvider();

  // Legacy sessions created before authProvider existed have a LoopBack token only.
  if (!provider) {
    return Boolean(window.localStorage.getItem('loopbackAccessToken'));
  }

  return provider === AUTH_PROVIDER_LEGACY;
};

// Use sync localStorage so APIcaller can read the provider immediately after login.
export const setLegacyAuthProvider = () => {
  window.localStorage.setItem(AUTH_PROVIDER_KEY, AUTH_PROVIDER_LEGACY);
};

export const setMosAuthProvider = () => {
  window.localStorage.removeItem('loopbackAccessToken');
  window.localStorage.setItem(AUTH_PROVIDER_KEY, AUTH_PROVIDER_MOS);
};

/**
 * Sync check used by the router shell. MOS sessions store userId after profile bootstrap;
 * the MOS access token itself is owned by @msw/oidc-ssr-adapter storage.
 */
export const hasAppSession = () => {
  const userId = window.localStorage.getItem('userId');

  if (!userId) {
    return false;
  }

  if (isMosAuthProvider()) {
    return true;
  }

  return Boolean(window.localStorage.getItem('loopbackAccessToken'));
};

export const clearAppSessionStorage = () => {
  window.localStorage.removeItem('loopbackAccessToken');
  window.localStorage.removeItem('userId');
  window.localStorage.removeItem('isCentralMode');
  window.localStorage.removeItem(AUTH_PROVIDER_KEY);
};
